import * as API from './API'

export default {

    //오디오 리스트
    async getAudioList(page, size, isDisplay, audioCategory1Uuid, audioCategory2Uuid, timeSearchType, bpmSearchType) {
        let parameters = {
            method: 'GET',
            path: '/p/api/audio',
            params: {
                'page': page,
                'size': size,
                'isDisplay': isDisplay,
                'audioCategory1Uuid': audioCategory1Uuid,
                'audioCategory2Uuid': audioCategory2Uuid,
                'timeSearchType': timeSearchType,
                'bpmSearchType': bpmSearchType,
                'sortType': 'sort' 
            }
        }
        const apiResponse = await API.request(parameters) 
        return apiResponse
    }

}



// WEBPACK FOOTER //
// ./src/service/audioAPI.js